module.exports = __webpack_public_path__ + "img/bottom2.9cff1556.png";